import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme.service';

@Component({
  selector: 'clz-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  index;


  show = 1;

  constructor(
    private themeService: ThemeService
  ) { }

  ngOnInit() {
    this.themeService.initHeaderStyle({ color: 'transparent' });
  }

}
